// Geometria da área registrada (polígono). Funções puras, testadas em geometria.test.js.

const RAIO_TERRA_M = 6371008.8;
const GRAU = Math.PI / 180;

/** Pontas válidas, na ordem de `posicao` (o servidor nem sempre devolve ordenado). */
export function pontasOrdenadas(coordenadas) {
  return (coordenadas || [])
    .map((c) => ({ lat: parseFloat(c.lat), lng: parseFloat(c.lng), posicao: Number(c.posicao) || 0 }))
    .filter((c) => Number.isFinite(c.lat) && Number.isFinite(c.lng))
    .sort((a, b) => a.posicao - b.posicao);
}

/**
 * Área aproximada do polígono, em hectares.
 *
 * Projeção equirretangular em torno do centro (x = R·cos(lat0)·Δlng, y = R·Δlat) e
 * fórmula do cordão (shoelace). Para o tamanho de uma propriedade (de alguns metros a
 * dezenas de km) o erro é desprezível; a mesma ideia do `AreaGeo` do app. Devolve 0
 * para menos de 3 pontas.
 */
export function areaEmHectares(coordenadas) {
  const pontas = pontasOrdenadas(coordenadas);
  if (pontas.length < 3) return 0;

  const lat0 = pontas.reduce((s, p) => s + p.lat, 0) / pontas.length;
  const lng0 = pontas.reduce((s, p) => s + p.lng, 0) / pontas.length;
  const cos0 = Math.cos(lat0 * GRAU);

  const xy = pontas.map((p) => ({
    x: RAIO_TERRA_M * cos0 * (p.lng - lng0) * GRAU,
    y: RAIO_TERRA_M * (p.lat - lat0) * GRAU,
  }));

  let soma = 0;
  for (let i = 0; i < xy.length; i++) {
    const a = xy[i];
    const b = xy[(i + 1) % xy.length];
    soma += a.x * b.y - b.x * a.y;
  }
  return Math.abs(soma) / 2 / 10000;
}

/** "12,4 ha" (pt-BR). Áreas pequenas mostram também os m². */
export function formatarArea(hectares) {
  if (!Number.isFinite(hectares) || hectares <= 0) return "—";
  const ha = hectares.toLocaleString("pt-BR", { maximumFractionDigits: hectares < 10 ? 2 : 1 });
  if (hectares < 1) return `${ha} ha (${Math.round(hectares * 10000).toLocaleString("pt-BR")} m²)`;
  return `${ha} ha`;
}
